import React from "react";
import { Grid } from "@material-ui/core";
import Layout from "../../common/Layout";
import PageHeader from "../../common/components/PageHeader/PageHeader";
import CareerBlock from "../../common/components/CareerBlock/CareerBlock";
import LoadingSpinner from "../../common/components/LoadingSpinner/LoadingSpinner";
import { useDashboard } from "../../hooks/useDashboard";

const CareerList = props => {
  /*const {
    loading: cLoading,
    error: cError,
    data: cCareers
  } = useQuery(GET_CAREERS, {
    fetchPolicy: "cache-and-network",
  });*/

  /*const {
    loading: cpLoading,
    error: cpError,
    data: cpData
  } = useQuery(GET_CAREERLIST_PAGE, {
    fetchPolicy: "cache-and-network",
  });*/
  const { isPending: isLoading, error, data } = useDashboard();
  if (isLoading) {
    return <LoadingSpinner styles={{ paddingTop: 60 }} />;
  }

  if (error) {
    return <div>Error! {error.message}</div>;
  }
  if (!data) return null;
  const { careerListPage, careerPaths } = data;
  const pageHeader = careerListPage?.data?.attributes?.pageHeader;
  return (
    <Layout>
        <>
          <PageHeader
            title={pageHeader.title}
            subTitle={pageHeader.description}
          />
          <Grid container spacing={4}>
            {careerPaths.map((career, index) => {
              return (
                <Grid key={`mtc-${index}`} item xs={12} md={6} lg={6} xl={4}>
                  <CareerBlock career={career} />
                </Grid>
              );
            })}
          </Grid>
        </>
    </Layout>
  );
};

export default CareerList;
